import { render, staticRenderFns } from "./DetailsUser.vue?vue&type=template&id=5e7334bc&scoped=true&"
import script from "./DetailsUser.vue?vue&type=script&lang=js&"
export * from "./DetailsUser.vue?vue&type=script&lang=js&"
import style0 from "./DetailsUser.vue?vue&type=style&index=0&id=5e7334bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7334bc",
  null
  
)

export default component.exports